// extracted by mini-css-extract-plugin
export default {"shortcut-overview-panel":"wZs8","shortcutOverviewPanel":"wZs8"};